import * as React from 'react';

import { useState, Fragment } from 'react';
import { useParams } from 'react-router-dom';
import StepOneIntro from './StepOneIntro';
import StepRegistration from './StepRegistration';
import { Paper, Box, Grid } from '@mui/material';
import Stepper from '@mui/material/Stepper';
import MobileStepper from '@mui/material/MobileStepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import StepFourteenJoin from './StepFourteenJoin';
import StepIntroduction from './StepIntroduction';
import './GlobalCssProgressBar.css';
import { StyledEngineProvider } from '@mui/material';

export default function HorizontalLinearStepper({ session, membershipLevel }) {
  // eslint-disable-next-line no-unused-vars
  const [loading, setLoading] = useState(false);
  const [activeStep, setActiveStep] = useState(0);

  let { id } = useParams();

  const steps = id
    ? ['Welcome', 'Registration', 'Join Telegram!']
    : ['Welcome', 'Registration', 'Introduction', 'Join Telegram!'];

  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const contentExistingMember = () => {
    switch (activeStep) {
      case 0:
        return <StepOneIntro activeStep={activeStep} handleBack={handleBack} handleNext={handleNext} steps={steps} />;
      case 1:
        return (
          <StepRegistration activeStep={activeStep} handleBack={handleBack} handleNext={handleNext} steps={steps} />
        );

      default:
        return (
          <StepFourteenJoin activeStep={activeStep} handleBack={handleBack} handleNext={handleNext} steps={steps} />
        );
    }
  };

  const contentNewMentor = () => {
    switch (activeStep) {
      case 0:
        return <StepOneIntro activeStep={activeStep} handleBack={handleBack} handleNext={handleNext} steps={steps} />;
      case 1:
        return (
          <StepRegistration activeStep={activeStep} handleBack={handleBack} handleNext={handleNext} steps={steps} />
        );
      case 2:
        return (
          <StepIntroduction activeStep={activeStep} handleBack={handleBack} handleNext={handleNext} steps={steps} />
        );

      default:
        return (
          <StepFourteenJoin activeStep={activeStep} handleBack={handleBack} handleNext={handleNext} steps={steps} />
        );
    }
  };

  return (
    <Fragment>
      {loading ? (
        'Loading ...'
      ) : (
        <Grid display='flex' direction='column' alignItems='center' justifyContent='center'>
          <Paper
            elevation={20}
            sx={{
              mt: '2rem',
              textAlign: 'left',
              width: { lg: 'min(900px, 60vw)' },
              position: 'relative',
              borderRadius: 5,
            }}>
            <Paper
              sx={{
                padding: '2rem',
                borderRadius: 5,
              }}>
              <Stepper activeStep={activeStep} alternativeLabel sx={{ display: { xs: 'none', md: 'flex' } }}>
                {steps.map((label, index) => {
                  const stepProps = {};
                  const labelProps = {};
                  return (
                    <Step key={label} {...stepProps}>
                      <StepLabel {...labelProps}></StepLabel>
                    </Step>
                  );
                })}
              </Stepper>
              <StyledEngineProvider injectFirst>
                <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                  <MobileStepper
                    variant='progress'
                    steps={id ? 3 : 4}
                    position='static'
                    activeStep={activeStep}
                    sx={{
                      flexGrow: 1,
                      display: { md: 'none' },
                      marginX: 'auto',
                      width: '100%',
                    }}
                  />
                </Box>
              </StyledEngineProvider>
              <Box
                sx={{
                  margin: 'auto',
                  width: { md: activeStep === 8 ? '100%' : 'min(600px, 40vw)' },
                }}>
                {id ? contentExistingMember() : contentNewMentor()}
              </Box>
            </Paper>
          </Paper>
        </Grid>
      )}
    </Fragment>
  );
}
